import React from 'react';

const GameHeader: React.FC = () => {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold text-gray-800">Goon Guessr</h1>
    </div>
  );
};

export default GameHeader; 